import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageTitle, Card, GBtn, Field, inputCls } from "./ui";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Save } from "lucide-react";

export default function ProductsAdmin() {
  const [products, setProducts] = useState([]);
  const load = () => api.get("/admin/products").then((r) => setProducts(r.data));
  useEffect(() => { load(); }, []);

  const upd = (i, k, v) => setProducts((p) => p.map((x, idx) => idx === i ? { ...x, [k]: v } : x));

  const save = async (p) => {
    const body = { ...p, price: parseFloat(p.price) || 0, videos: parseInt(p.videos) || 0,
      features: Array.isArray(p.features) ? p.features : String(p.features).split("\n").filter(Boolean) };
    await api.put(`/admin/products/${p.id}`, body);
    toast.success("Saved"); load();
  };

  return (
    <>
      <PageTitle title="Products & Pricing" subtitle="Content Plan packages" />
      <div className="grid lg:grid-cols-2 gap-4">
        {products.map((p, i) => (
          <Card key={p.id} className="space-y-3">
            <Field label="Name"><input value={p.name} onChange={(e) => upd(i, "name", e.target.value)} className={inputCls} /></Field>
            <div className="grid grid-cols-2 gap-3">
              <Field label="Price (£)"><input type="number" step="0.01" value={p.price} onChange={(e) => upd(i, "price", e.target.value)} data-testid={`product-price-${i}`} className={inputCls} /></Field>
              <Field label="Videos"><input type="number" value={p.videos} onChange={(e) => upd(i, "videos", e.target.value)} className={inputCls} /></Field>
            </div>
            <Field label="Description"><textarea rows={2} value={p.description} onChange={(e) => upd(i, "description", e.target.value)} className={inputCls} /></Field>
            <Field label="Features (one per line)">
              <textarea rows={5} value={Array.isArray(p.features) ? p.features.join("\n") : p.features} onChange={(e) => upd(i, "features", e.target.value.split("\n"))} className={inputCls} />
            </Field>
            <div className="flex items-center gap-6">
              <label className="flex items-center gap-2 text-sm"><Switch checked={!!p.best_value} onCheckedChange={(v) => upd(i, "best_value", v)} /> Best value</label>
              <label className="flex items-center gap-2 text-sm"><Switch checked={!!p.active} onCheckedChange={(v) => upd(i, "active", v)} /> Active</label>
            </div>
            <GBtn onClick={() => save(p)} data-testid={`product-save-${i}`}><Save size={15} /> Save</GBtn>
          </Card>
        ))}
      </div>
    </>
  );
}
